import { render, staticRenderFns } from "./RoomDetails.vue?vue&type=template&id=3b0283d8"
import script from "./RoomDetails.vue?vue&type=script&lang=js"
export * from "./RoomDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports